import { useCallback } from "react";
import { Globe } from "lucide-react";
import { useLocale, useSetLocale } from "next-intl";

export function LocaleToggleUnauth() {
  const locale = useLocale();
  const setLocale = useSetLocale();
  const isEn = locale === "en";

  const toggle = useCallback(() => {
    setLocale(isEn ? "zh-CN" : "en");
  }, [isEn, setLocale]);

  return (
    <button
      aria-label={
        isEn ? "Switch language to Chinese" : "Switch language to English"
      }
      className="flex size-10 cursor-pointer items-center justify-center rounded-full border border-white/10 bg-white/[0.03] text-sm font-medium text-white/78 shadow-[inset_0_1px_0_rgba(255,255,255,0.08)] transition-all duration-200 hover:border-white/16 hover:bg-white/[0.06] hover:text-white"
      onClick={toggle}
    >
      <Globe size={17} />
    </button>
  );
}
